import CollectionList from '@/js/Shared/Collections/CollectionList';
import FiltersItem    from '../Entities/FiltersItem.js';
import CollectionSearch from '@/js/Shared/Collections/CollectionSearch.js';

export { FiltersCollectionList as default };

/**
* Filters List Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FiltersCollectionList extends CollectionList
{
  search_list = new CollectionSearch('name');ww

    constructor(index_id) {
      super(index_id);
      this.search_list.setSearchList(this);
    }

  /**
   * Returns a filter on the list by the given id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id filter id
   *
   * @return {FiltersItem}
   */
  get(id) {
    return this.index[id] || new FiltersItem();
  }

  /**
   * Returns a clone of the filter given by the id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id filter id
   *
   * @return {FiltersItem}
   */
  getClone(id) {
    let filter       = this.get(id)
    let clone        = Object.assign(new FiltersItem(), filter)
    clone.conditions = [...filter.conditions]
    clone.flags      = {...filter.flags}
    return clone
  }

  search(term) {
      this.search_list.term = term;
      this.search_list.search(term, {
          name: ['lower_case', 'latinize'],
      })
  }

  /**
   * Resorts filters items alphabeticly
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  resortItems() {
    this.items.sort((a,b) => {
      return a.name.localeCompare(b.name, undefined, { numeric: true });
    })
  }
}